import { useEffect, useMemo, useState } from 'react';
import { listAnalyticsRuleOptions } from '../../../services/violations';
import { toScopeQuery } from '../../../utils/scopeSelection';

const HIDDEN_STATUSES = new Set([403, 404, 501]);

/** Отслеживаются только включённые правила; без флага правило считаем включённым. */
export const countEnabledRules = (items) => (Array.isArray(items) ? items : [])
  .filter((rule) => rule?.enabled !== false).length;

/*
 * «Отслеживаемые бизнес-метрики» на вкладке «Контроль». executive-summary
 * считает в kpis.active_rules только правила нарушений, поэтому бизнес-правила
 * берём из ACL-aware GET /analytics/business-rules с тем же scope.
 *
 * value: число, null — пока грузится или не удалось, hidden — нет доступа
 * к бизнес-метрикам (карточку не показываем).
 */
export const useBusinessRulesCount = ({ scope, enabled = true }) => {
  const scopeKey = useMemo(() => JSON.stringify(toScopeQuery(scope)), [scope]);
  const [state, setState] = useState({ key: '', value: null, hidden: false });

  useEffect(() => {
    if (!enabled) return undefined;
    const controller = new AbortController();
    listAnalyticsRuleOptions('business', JSON.parse(scopeKey), { signal: controller.signal })
      .then((response) => {
        if (controller.signal.aborted) return;
        setState({ key: scopeKey, value: countEnabledRules(response?.items), hidden: false });
      })
      .catch((error) => {
        if (controller.signal.aborted) return;
        setState({ key: scopeKey, value: null, hidden: HIDDEN_STATUSES.has(error?.response?.status) });
      });
    return () => controller.abort();
  }, [enabled, scopeKey]);

  // Значение прошлого scope не показываем как текущее.
  return state.key === scopeKey ? state : { key: scopeKey, value: null, hidden: false };
};

export default useBusinessRulesCount;
